<form (keydown.enter)="$event.preventDefault()" [formGroup]="checkInForm">
  <mat-card class="mat-elevation-z14">
    <mat-card-content>
      <h2 i18n="@@checkIn">Check In</h2>

      <p i18n="@@checkInGuidance">
        Please provide us the following information and touch the button below to check
        in.
      </p>

      <div>
        <mat-form-field>
          <input
            matInput
            formControlName="tag"
            name="tag"
            type="tel"
            placeholder="Badge #"
            i18n-placeholder="@@formLabelBadge"
            maxlength="8"
          />
          <mat-hint align="end"
            >{{ checkInForm.get('tag').value.length || 0 }}/8</mat-hint
          >
        </mat-form-field>

        <mat-form-field>
          <input
            matInput
            formControlName="cellphone"
            name="cellphone"
            type="tel"
            placeholder="Cell phone"
            i18n-placeholder="@@formLabelCellphone"
            minlength="10"
            maxlength="10"
          />
          <mat-hint align="start" i18n="@@formHintCellphone"
            >10 digits US format</mat-hint
          >
          <mat-hint align="end"
            >{{ checkInForm.get('cellphone').value.length || 0 }}/10</mat-hint
          >
        </mat-form-field>

        <mat-form-field>
          <input
            matInput
            formControlName="first_name"
            name="first_name"
            type="text"
            autocapitalize="words"
            placeholder="First name"
            i18n-placeholder="@@formLabelFirstName"
          />
        </mat-form-field>

        <mat-form-field>
          <input
            matInput
            formControlName="last_name"
            name="last_name"
            type="text"
            autocapitalize="words"
            placeholder="Last name"
            i18n-placeholder="@@formLabelLastName"
          />
        </mat-form-field>

        @if (state.showAppointmentTime) {
          @switch (localeId) {
            @case ('de') {
              <frontend-time-input-24hs [form]="checkInForm"></frontend-time-input-24hs>
            }
            @default {
              <frontend-time-input-ampm [form]="checkInForm"></frontend-time-input-ampm>
            }
          }
        }

        <mat-form-field *ngIf="state.showProvider">
          <mat-select
            matInput
            formControlName="assigned_staff_id"
            name="provider"
            type="text"
            autocapitalize="words"
            placeholder="Provider"
            i18n-placeholder="@@formLabelProvider"
          >
            <mat-option *ngFor="let s of state.staff" [value]="s.id"
              >{{ s.last_name }}, {{ s.first_name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>

      <button
        id="check-in-btn"
        mat-raised-button
        [disabled]="checkInForm.invalid || state.loading"
        (click)="submit(checkInForm.value)"
        i18n="@@formCheckInBtn"
      >
        CHECK IN NOW
      </button>
    </mat-card-content>
  </mat-card>
</form>
